import {
  FETCH_DRIVERPROF_ACTION,
  FETCH_DRIVERPROF_SUCCESS_ACTION,
  FETCH_DRIVERPROF_FAIL_ACTION,
  FETCH_DRIVERBYID_SUCCESS_ACTION,
  FETCH_OPENDRIVER_SUCCESS_ACTION,
  DELETE_DRIVERLIST_ACTION
} from "./action";

const initialState = {
  prcssng: false,
  error: false,
  fetchdriverList: null
};

export default function (state: any = initialState, action: Function) {
  switch (action.type) {


    default:
      return {
        ...state,
      };
  }
}
